// This needs to be in global scope otherwise it wont work. I have no idea why not, it took too
// long to diagnose the issue to spend time trying to find out why.
if ($.validator && $.validator.unobtrusive) {

	$.validator.pushpay = $.validator.pushpay || {};

	$.validator.pushpay.getRelatedElement = function (element, relatedElementName) {
		var otherElementName = relatedElementName || "";
		if (!element || element.length < 0 || !otherElementName || otherElementName.length < 1) {
			return null;
		}

		// Go for the ID first
		var otherElement = $('[id="' + otherElementName + '"]');
		if (otherElement.length > 0) {
			return otherElement;
		}

		// Try for name in case its a radio button
		otherElement = $('[name="' + otherElementName + '"]');
		if (otherElement.length > 0) {
			return otherElement;
		}

		// It might be one of those funky asp.net controls with crazy id's
		var pos = element.id.lastIndexOf("_") + 1;
		var fullId = element.id.substr(0, pos) + otherElementName.replace(/\./g, "_");
		otherElement = $('[id="' + fullId + '"]');
		if (otherElement.length > 0) {
			return otherElement;
		}

		// Or it could be a funky asp.net radio button
		pos = element.name.lastIndexOf(".") + 1;
		var fullName = element.name.substr(0, pos) + otherElementName;
		otherElement = $('[name="' + fullName + '"]');

		return otherElement;
	}

	$.validator.pushpay.isConditionMet = function (element, conditionalPropertyName, conditionalValue) {
		var conditionalProperty = $.validator.pushpay.getRelatedElement(element, conditionalPropertyName);

		if (conditionalProperty.length < 1) {
			return false;
		}

		var conditionalType = conditionalProperty.attr("type");

		var conditionValue = $.validator.prototype.elementValue.call(this, conditionalProperty);

		if (conditionValue == undefined && (conditionalType === "radio" || conditionalType === "checkbox")) {
			conditionValue = "false";
		}

		var testValue = conditionalValue;

		if (!conditionValue || !testValue || conditionValue.toLowerCase() !== testValue.toLowerCase()) {
			return false;
		}

		return true;
	}

	$.validator.pushpay.comparisons = {
		LessThan: function(a, b) {
			return a < b;
		},
		GreaterThan: function(a, b) {
			return a > b;
		},
		LessThanOrEqual: function(a, b) {
			return a <= b;
		},
		GreaterThanOrEqual: function(a, b) {
			return a >= b;
		},
		Equal: function(a, b) {
			return a === b;
		}
	};

	$.validator.addMethod("datecomparison", function (value, element, params) {
		var otherDateElement = $.validator.pushpay.getRelatedElement(element, params.otherPropertyName);

		if (!otherDateElement) {
			// if we can't find the other element, default to true (safer then breaking all the things)
			return true;
		}

		var comparer = $.validator.pushpay.comparisons[params.comparisonType];

		if (!comparer) {
			// unknown comparison type, bail out.
			console.log('WARNING - unknown comparison type specified for datacomparison: ' + params.comparisonType);
			return true;
		}

		var otherDateRawValue = otherDateElement.val();

		// probably should use moment I guess?
		if (!/Invalid|NaN/.test(new Date(value))) {
			return comparer(new Date(value), new Date(otherDateRawValue));
		}

		return isNaN(value) && isNaN(otherDateRawValue)
			|| comparer(Number(value), Number(otherDateRawValue));
	}, 'You must configure a specific validation message for this validation type.');

} else {
	console.log('WARNING - The jquery validator hasn\'t yet been defined');
}
